import React from 'react'
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import Accordion from 'components/Common/Accordion/Accordion'
import { BtnBack, BtnCancelInModal, BtnConfirm, BtnSend } from 'components/Common/Button';
import GoogleMapComp from 'view/Map/GoogleMapComp';
import Geocode from "react-geocode";

interface propPopUpMap {
    IsOpen?: boolean;
    setIsOpen: any;
    sMaxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    setsLocation?: any;
    oLocationCurrent?: any;
    setoLocationCurrent?: any;
    onCancel?: ()=> void;
    onConfirm?: ()=> void;
}
const CpnPopUpMap = (props: propPopUpMap) => {

    const { IsOpen, setIsOpen, sMaxWidth = "md", setsLocation, oLocationCurrent,setoLocationCurrent,onConfirm,onCancel } = props;

    const onGetAddressfromLatLng = async (ParamLat, ParamLng)=>{
        let address = "";
        await Geocode.fromLatLng(ParamLat, ParamLng).then(
          (response) => {
            address = response.results[0].formatted_address;
          },
          (error) => {
            console.error("Get Address Error",error);
          }
        );
        return address;
      }

    return (
        <Dialog
            open={IsOpen}
            onClose={() => { setIsOpen(!IsOpen); }}
            aria-labelledby="alert-dialog-title-map"
            aria-describedby="alert-dialog-map"
            fullWidth={true}
            maxWidth={sMaxWidth}
        >
            <DialogTitle>
                <Typography>สถานที่</Typography>
            </DialogTitle>
            <hr style={{ width: '100%', margin: '0' }} />
            <DialogContent>
                <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center" >
                    <Grid item xs={12}>
                        <GoogleMapComp
                            MapHeight={"400px"}
                            oLocationCurrent={oLocationCurrent}
                            setoLocationCurrent={setoLocationCurrent}
                        /> 
                    </Grid>
                </Grid>
            </DialogContent>
            <hr style={{ width: '100%', margin: '0' }} />
            <DialogActions>
                <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center" >
                    <Grid item>
                        <BtnConfirm 
                            txt={"ยืนยัน"} 
                            onClick={ async () => { 
                                let address = await onGetAddressfromLatLng(oLocationCurrent.lat, oLocationCurrent.lng);
                                setsLocation({
                                    Latitude: oLocationCurrent.lat,
                                    Longitude: oLocationCurrent.lng,
                                    Address: address,
                                  })

                                if(onConfirm){
                                    onConfirm()
                                }
                                setIsOpen(!IsOpen);
                            }} 
                        />
                    </Grid>
                    <Grid item>
                        <BtnCancelInModal 
                            onClick={() => { 
                                if(onCancel){
                                    onCancel()
                                }
                                setIsOpen(!IsOpen); 
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default CpnPopUpMap